import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Origin } from '@classes/origin/origin';
import { OriginYear } from '@classes/origin/origin-year';
import { OriginService } from '@services/origin.service';
import { SimulationService } from '@services/simulation.service';
import { NavService } from '@services/nav.service';
import { OriginConfig } from '@classes/origin/origin-config';
import { NavLink } from '@classes/nav-link';
import { Subscription } from 'rxjs';
import { UserService } from '@services/user.service';
import { ProviderType } from '@enums/provider-type.enum';

@Component({
    selector: 'app-year-select-form',
    templateUrl: './year-select-form.component.html',
    styleUrls: ['./year-select-form.component.scss']
})
export class YearSelectFormComponent implements OnInit, OnDestroy {
    @Input() years: OriginYear[];
    @Input() userOrigin: Origin;

    private userParametersSub: Subscription;

    yearsForm: FormGroup;
    paramLink: NavLink;
    isParamLinkVisible: boolean;
    providerType = ProviderType;

    constructor(
        private originSrv: OriginService,
        private fb: FormBuilder,
        private simulationSrv: SimulationService,
        private userSrv: UserService,
        private navSrv: NavService
    ) { }

    ngOnInit() {
        this.initSubscriptions();
        this.paramLink = this.navSrv.getLinkFromRoute(['parameters', 'config-provider'], 'settings');
    }

    private initSubscriptions(): void {
        this.userParametersSub = this.userSrv.userParametersSubject
        .subscribe(userParams => {
            this.userOrigin = userParams.origin;
            this.initForm();
        });
    }
    private initForm(): void {
        this.yearsForm = this.fb.group({
            year: [this.userOrigin.selectedLastYear.code]
        });

        this.yearsForm.controls.year.valueChanges
        .subscribe((yearFromSelect: string) => {
            this.submitYear(yearFromSelect);
        });

        this.isParamLinkVisible = this.userOrigin.provider.code !== ProviderType.bbc;
    }
    private submitYear(yearCode: string): void {
        const year = this.years.find(y => y.code === yearCode);
        const newConfig = new OriginConfig({year: year.year, amountStageCode: year.amountStageCode});

        this.originSrv.set(newConfig, true)
        .subscribe(() => {
            this.simulationSrv.get().subscribe();
            this.simulationSrv.getPartitioningsList().subscribe();
            this.initForm();
        });
    }

    ngOnDestroy() {
        if(this.userParametersSub) {
            this.userParametersSub.unsubscribe();
        }
    }
}
